/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetMerchantRequest} from '@cash-web/protos/squareup/roster/mds.pb'
import {GetMerchantResponse} from '@cash-web/protos/squareup/roster/mds.pb'


export const getMerchant = (request: GetMerchantRequest, options?: CashRequestOptions) => post<GetMerchantRequest, GetMerchantResponse>("/2.0/cash/get-merchant", request, {...options, rejectOnError: true })